(function () {
  function initRoutineHub(root) {
    if (!root) return;

    var tabs = root.querySelectorAll('[data-al-rh-tab]');
    var panels = root.querySelectorAll('[data-al-rh-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-al-rh-tab');

        tabs.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var activePanel = root.querySelector('[data-al-rh-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });

    var timeTabs = root.querySelectorAll('[data-al-rh-time-tab]');
    var timePanels = root.querySelectorAll('[data-al-rh-time-panel]');

    timeTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-al-rh-time-tab');

        timeTabs.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        timePanels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var activePanel = root.querySelector('[data-al-rh-time-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.al-rh').forEach(initRoutineHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
